import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NihlAnalayseService {

  constructor(
    public apiService: ApiService
  ) { }

  public calculate(requestParam: {}): Observable<any> {
    return this.apiService.postService('nihl/calculate', requestParam);
  }
  public getAudiogramMeta(requestParam: {}){
    return this.apiService.postService('nihl/claim-overview', requestParam);
  }
  public add_audiometry_preset_filters(requestParam: {}){
    return this.apiService.postService('workflow/activity', requestParam);
  }
}
